import { createSelector } from 'reselect'

const getUserLogged = state => state.user.logged

const privateLibraryRouteSelector = createSelector(
	[ getUserLogged ],
	userLogged => {
		const isReadyToRender = userLogged !== null

		return {
			isReadyToRender,
		}
	}
)

export default privateLibraryRouteSelector
